import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import PropTypes from "prop-types";
import { FormControl, Grid, MenuItem, Select } from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import KpiCard from "../../components/KpiCard/KpiCard";
import IconBrasil from "../../assets/icons/icon-brasil.svg";
import styled from "styled-components";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  padding: 0 16px;
`;

function OverviewMobile({ app, config }) {
  const { selections } = useSelections();
  const [regional, setGegional] = useState("Regionais");

  const [pColor, setPColor] = useState();
  const [pColor2, setPColor2] = useState();
  const [pColor3, setPColor3] = useState();
  const [pColor4, setPColor4] = useState();
  const [pColor5, setPColor5] = useState();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);

  function createClassNameForPorcente(percentage) {
    if (percentage < 50) {
      return "better";
    } else if (percentage < 99) {
      return "good";
    } else {
      return "great";
    }
  }

  async function getColorfromPorcente1() {
    const data = await app.visualization.get("EpDrght");
    const porcente =
      await data.model?.layout.qHyperCube?.qGrandTotalRow[0].qText.replace(
        "%",
        ""
      );
    setPColor(parseFloat(porcente));
  }

  async function getColorfromPorcente2() {
    const data = await app.visualization.get("MmhhGQ");
    const porcente =
      await data.model?.layout.qHyperCube?.qGrandTotalRow[0].qText.replace(
        "%",
        ""
      );
    setPColor2(parseFloat(porcente));
  }

  async function getColorfromPorcente3() {
    const data = await app.visualization.get("hEaNHnW");
    const porcente =
      await data.model?.layout.qHyperCube?.qGrandTotalRow[0].qText.replace(
        "%",
        ""
      );
    setPColor3(parseFloat(porcente));
  }

  async function getColorfromPorcente4() {
    const data = await app.visualization.get("ansesvy");
    const porcente =
      await data.model?.layout.qHyperCube?.qGrandTotalRow[0].qText.replace(
        "%",
        ""
      );
    setPColor4(parseFloat(porcente));
  }

  async function getColorfromPorcente5() {
    const data = await app.visualization.get("KJeqXw");
    const porcente =
      await data.model?.layout.qHyperCube?.qGrandTotalRow[0].qText.replace(
        "%",
        ""
      );
    setPColor5(parseFloat(porcente));
  }

  useEffect(() => {
    if (app) {
      // update title with selected distributor (when only 1 is selected)
      getColorfromPorcente1();
      getColorfromPorcente2();
      getColorfromPorcente3();
      getColorfromPorcente4();
      getColorfromPorcente5();
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Desc_Vis")
        : null;
      setGegional(selections[0]?.qSelected);
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  function handleChange(event) {
    app.field("Desc_Vis").selectMatch(event.target.value, true);
    setGegional(event.target.value);
  }

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutCardWrapper>
          <Grid
            container
            direction="row"
            flexWrap={"wrap"}
            alignItems={"center"}
            justifyContent={"center"}
            gap={"16px"}
            style={{
              width: "100%",
              height: "auto",
              marginTop: "19px",
              marginLeft: "0px",
            }}
          >
            <Grid
              item
              style={{ maxWidth: "100%", width: "45%", paddingLeft: "0" }}
              cl50sName="container-card-overview"
            >
              <Card
                header={{
                  hardTitle: "NENO",
                }}
                style={{
                  width: "100%",
                  height: "auto",
                  position: "relative",
                }}
                classStyle={"row-header"}
              >
                <div className="container-items">
                  <NativeObject
                    className="kpiValueBold"
                    app={app}
                    key="XPQzjUb"
                    reference={{
                      id: "XPQzjUb",
                    }}
                  />

                  <div className="container-img">
                    <img src={IconBrasil} alt="icon" />
                  </div>
                </div>
              </Card>
            </Grid>

            <Grid
              item
              style={{ maxWidth: "100%", width: "45%", paddingLeft: "0" }}
              className="container-card-overview"
            >
              <Card
                header={{
                  hardTitle: "RIMES",
                }}
                style={{
                  width: "100%",
                  height: "auto",
                  position: "relative",
                }}
                classStyle={"row-header"}
              >
                <div className="container-items">
                  <NativeObject
                    className="kpiValueBold"
                    app={app}
                    key="DegAcww"
                    reference={{ id: "DegAcww" }}
                  />

                  <div className="container-img">
                    <img src={IconBrasil} alt="icon" />
                  </div>
                </div>
              </Card>
            </Grid>

            <Grid
              item
              style={{ maxWidth: "100%", width: "45%", paddingLeft: "0" }}
              cl50sName="container-card-overview"
            >
              <Card
                header={{
                  hardTitle: "SP+CTO",
                }}
                style={{
                  width: "100%",
                  height: "auto",
                  position: "relative",
                }}
                classStyle={"row-header"}
              >
                <div className="container-items">
                  <NativeObject
                    className="kpiValueBold"
                    app={app}
                    key="NjWPumj"
                    reference={{ id: "NjWPumj" }}
                  />

                  <div className="container-img">
                    <img src={IconBrasil} alt="icon" />
                  </div>
                </div>
              </Card>
            </Grid>

            <Grid
              item
              style={{ maxWidth: "100%", width: "45%", paddingLeft: "0" }}
              className="container-card-overview"
            >
              <Card
                header={{
                  hardTitle: "SUL",
                }}
                style={{
                  width: "100%",
                  height: "auto",
                  position: "relative",
                }}
                classStyle={"row-header"}
              >
                <div className="container-items">
                  <NativeObject
                    className="kpiValueBold"
                    app={app}
                    key="Mrru"
                    reference={{ id: "Mrru" }}
                  />

                  <div className="container-img">
                    <img src={IconBrasil} alt="icon" />
                  </div>
                </div>
              </Card>
            </Grid>
          </Grid>
        </LayoutCardWrapper>

        {/* Total Brasil */}
        <h2>Total Brasil</h2>
        <LayoutCardWrapper>
          <Grid
            container
            display={"flex"}
            direction="column"
            justifyContent={"space-around"}
            alignItems={"center"}
            style={{
              width: "100%",
              height: "auto",
              margin: "19px auto 24px auto",
            }}
            className="line-2"
          >
            <Grid
              item
              style={{ maxWidth: "100%", marginBottom: "16px" }}
              className="container-card-overview faturamento"
            >
              <Card
                header={{
                  hardTitle: "Faturamento",
                }}
                style={{
                  width: "100%",
                  height: "auto",
                }}
                classStyle={"row-header"}
              >
                <div className="container-items faturamento">
                  <div className="container-line containe-meta">
                    <p>Meta</p>

                    <NativeObject
                      className={"kpiValueBold"}
                      style={{ height: "40px" }}
                      app={app}
                      key="hPhZzz"
                      reference={{
                        id: "hPhZzz",
                      }}
                    />
                  </div>

                  <div className="container-line container-ating">
                    <p>Ating.</p>

                    <NativeObject
                      className={`kpiValueBold ${createClassNameForPorcente(
                        pColor
                      )}`}
                      style={{ height: "40px" }}
                      app={app}
                      key="EpDrght"
                      reference={{
                        id: "EpDrght",
                      }}
                    />
                  </div>
                </div>
              </Card>
            </Grid>

            <Grid
              item
              style={{ maxWidth: "100%", marginBottom: "16px" }}
              className="container-card-overview msl"
            >
              <Card
                header={{
                  hardTitle: "MSL",
                }}
                style={{
                  width: "100%",
                  height: "auto",
                }}
                classStyle={"row-header"}
              >
                <div className="container-items msl">
                  <div className="container-line containe-meta">
                    <p>Meta</p>

                    <NativeObject
                      className="kpiValueBold"
                      style={{ height: "40px" }}
                      app={app}
                      key="YGCZxF"
                      reference={{
                        id: "YGCZxF",
                      }}
                    />
                  </div>

                  <div className="container-line container-ating">
                    <p>Ating.</p>

                    <NativeObject
                      className={`kpiValueBold ${createClassNameForPorcente(
                        pColor2
                      )}`}
                      style={{ height: "40px" }}
                      app={app}
                      key="MmhhGQ"
                      reference={{
                        id: "MmhhGQ",
                      }}
                    />
                  </div>
                </div>
              </Card>
            </Grid>

            <Grid
              item
              style={{ maxWidth: "100%", marginBottom: "16px" }}
              className="container-card-overview ponto"
            >
              <Card
                header={{
                  hardTitle: "Ponto Extra",
                }}
                style={{
                  width: "100%",
                  height: "auto",
                }}
                classStyle={"row-header"}
              >
                <div className="container-items ponto">
                  <div className="container-line containe-meta">
                    <p>Meta</p>

                    <NativeObject
                      className="kpiValueBold"
                      style={{ height: "40px" }}
                      app={app}
                      key="zPYkqW"
                      reference={{
                        id: "zPYkqW",
                      }}
                    />
                  </div>

                  <div className="container-line container-ating">
                    <p>Ating.</p>

                    <NativeObject
                      className={`kpiValueBold ${createClassNameForPorcente(
                        pColor3
                      )}`}
                      style={{ height: "40px" }}
                      app={app}
                      key="hEaNHnW"
                      reference={{
                        id: "hEaNHnW",
                      }}
                    />
                  </div>
                </div>
              </Card>
            </Grid>

            <Grid
              item
              style={{ maxWidth: "100%", marginBottom: "16px" }}
              className="container-card-overview inovacoes"
            >
              <Card
                header={{
                  hardTitle: "Inovações",
                }}
                style={{
                  width: "100%",
                  height: "auto",
                }}
                classStyle={"row-header"}
              >
                <div className="container-items inovacoes">
                  <div className="container-line containe-meta">
                    <p>Meta</p>

                    <NativeObject
                      className="kpiValueBold"
                      style={{ height: "40px" }}
                      app={app}
                      key="CemLkz"
                      reference={{
                        id: "CemLkz",
                      }}
                    />
                  </div>

                  <div className="container-line container-ating">
                    <p>Ating.</p>

                    <NativeObject
                      className={`kpiValueBold ${createClassNameForPorcente(
                        pColor4
                      )}`}
                      style={{ height: "40px" }}
                      app={app}
                      key="ansesvy"
                      reference={{
                        id: "ansesvy",
                      }}
                    />
                  </div>
                </div>
              </Card>
            </Grid>

            <Grid
              item
              style={{ maxWidth: "100%" }}
              className="container-card-overview total"
            >
              <Card
                header={{
                  hardTitle: "Total PDV Premiado",
                }}
                style={{
                  width: "100%",
                  height: "auto",
                }}
                classStyle={"row-header"}
              >
                <div className="container-items total">
                  <div className="container-line containe-meta">
                    <p>Meta</p>

                    <NativeObject
                      className="kpiValueBold"
                      style={{ height: "40px" }}
                      app={app}
                      key="kXKDZZ"
                      reference={{
                        id: "kXKDZZ",
                      }}
                    />
                  </div>

                  <div className="container-line container-ating">
                    <p>Ating.</p>

                    <NativeObject
                      className={`kpiValueBold ${createClassNameForPorcente(
                        pColor5
                      )}`}
                      style={{ height: "40px" }}
                      app={app}
                      key="KJeqXw"
                      reference={{
                        id: "KJeqXw",
                      }}
                    />
                  </div>
                </div>
              </Card>
            </Grid>
          </Grid>
        </LayoutCardWrapper>

        <div className="container-select">
          <span>Selecione uma opção: </span>
          <FormControl sx={{ border: "none" }}>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={regional}
              label="tetse"
              onChange={handleChange}
              sx={{
                border: "none",
                width: "150px",
                background: "#EFEFEF",
                height: "26px",
              }}
            >
              <MenuItem value={"Regionais"}>Regionais</MenuItem>
              <MenuItem value={"Grupo Econômico"}>Grupo Econômico</MenuItem>
            </Select>
          </FormControl>
        </div>

        <LayoutCardWrapper>
          <Grid
            container
            rowGap={2}
            marginTop={"16px"}
            paddingLeft={"2px"}
            height={"814px"}
            width={"100%"}
            gap={"16px"}
          >
            <Grid item width={"100%"}>
              <Card
                app={app}
                header={{
                  hardTitle: "Faturamento",
                }}
                exportTable
                exportTableId="pdzJKUp"
                style={{ width: "100%", height: "100%" }}
                className={"container-table-kpi"}
              >
                <KpiCard
                  app={app}
                  percentageId={"EpDrght"}
                  valueId={"ZFhUnm"}
                  goalValueId={"hPhZzz"}
                  hasProgressBar={true}
                  fullView
                ></KpiCard>

                <h2>{regional}</h2>

                <NativeObject
                  app={app}
                  key="pdzJKUp"
                  reference={{ id: "pdzJKUp" }}
                />
              </Card>
            </Grid>

            <Grid item width={"100%"}>
              <Card
                app={app}
                header={{
                  hardTitle: "MSL",
                }}
                exportTable
                exportTableId="PhRvLe"
                style={{ width: "100%", height: "100%" }}
                className={"container-table-kpi"}
              >
                <KpiCard
                  app={app}
                  percentageId={"MmhhGQ"}
                  valueId={"VYLJTD"}
                  goalValueId={"YGCZxF"}
                  hasProgressBar={true}
                  fullView
                ></KpiCard>

                <h2>{regional}</h2>

                <NativeObject
                  app={app}
                  key="PhRvLe"
                  reference={{ id: "PhRvLe" }}
                />
              </Card>
            </Grid>
          </Grid>
        </LayoutCardWrapper>

        <LayoutCardWrapper>
          <Grid
            container
            rowGap={2}
            marginTop={"16px"}
            paddingLeft={"2px"}
            height={"814px"}
            width={"100%"}
            gap={"16px"}
          >
            <Grid item width={"100%"}>
              <Card
                app={app}
                header={{
                  hardTitle: "Ponto Extra",
                }}
                exportTable
                exportTableId="xyXSS"
                style={{ width: "100%", height: "100%" }}
                className={"container-table-kpi"}
              >
                <KpiCard
                  app={app}
                  percentageId={"hEaNHnW"}
                  valueId={"QGHhS"}
                  goalValueId={"zPYkqW"}
                  hasProgressBar={true}
                  fullView
                ></KpiCard>

                <h2>{regional}</h2>

                <NativeObject
                  app={app}
                  key="xyXSS"
                  reference={{ id: "xyXSS" }}
                />
              </Card>
            </Grid>

            <Grid item width={"100%"}>
              <Card
                app={app}
                header={{
                  hardTitle: "Inovações",
                }}
                exportTable
                exportTableId="MYPxTp"
                style={{ width: "100%", height: "100%" }}
                className={"container-table-kpi"}
              >
                <KpiCard
                  app={app}
                  percentageId={"ansesvy"}
                  valueId={"QDCN"}
                  goalValueId={"CemLkz"}
                  hasProgressBar={true}
                  fullView
                ></KpiCard>

                <h2>{regional}</h2>

                <NativeObject
                  app={app}
                  key="MYPxTp"
                  reference={{ id: "MYPxTp" }}
                />
              </Card>
            </Grid>
          </Grid>
        </LayoutCardWrapper>

        <LayoutCardWrapper style={{ marginTop: "16px", height: "934px" }}>
          <Grid item width={"100%"}>
            <Card
              app={app}
              header={{
                hardTitle: "Total PDV Premiado",
              }}
              exportTable
              exportTableId="RKmKmS"
              style={{ width: "100%", height: "100%" }}
              className={"container-table-kpi"}
            >
              <KpiCard
                app={app}
                percentageId={"KJeqXw"}
                valueId={"fJVNLXH"}
                goalValueId={"kXKDZZ"}
                hasProgressBar={true}
                fullView
              ></KpiCard>

              <h2>{regional}</h2>

              <NativeObject
                app={app}
                key="RKmKmS"
                reference={{ id: "RKmKmS" }}
              />
            </Card>
          </Grid>
        </LayoutCardWrapper>
      </div>
    </div>
  );
}

OverviewMobile.defaultProps = {
  app: null,
  config: {},
};

OverviewMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OverviewMobile;
